import { flexeraItVisibility } from "../flexeraItVisibility/manifest";
import { flexeraSoftwareVulnerabilityResearch } from "../flexeraSoftwareVulnerabilityResearch/manifest";
import { defineProduct } from "../types";
import logo from "./logo.svg";
export const flexera = defineProduct({
  name: "Flexera",
  tagLine: "IT visibility and vulnerability intelligence",
  logo,
  tags: ["security"],
  variants: [flexeraItVisibility, flexeraSoftwareVulnerabilityResearch],
});
